import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import MiniDrawer from '../../components/navigation/DrawerMenu'
import { withStyles } from '@material-ui/styles';
import BarcodeReader from 'react-barcode-reader'
import {Warehouse} from "../../_helpers/auth-header";
import SalesScanDetail from '../../components/sales/detail'
const drawerWidth = 240;
const styles = (theme) => ({
    toolbar: theme.mixins.toolbar,
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
});

const Home = (props) => {
    const { classes } = props;
    //this.setStatestate.gridType = props.gridType;
    return (
        <React.Fragment>
            <CssBaseline />
            <MiniDrawer title={" - Scannen van solden " + Warehouse()}>
            <Grid>
                    <SalesScanDetail />
            </Grid>
            </MiniDrawer>
        </React.Fragment>
    );
}


export default withStyles(styles)(Home);